import React from 'react';
import useFetch from 'components/shared/hooks/useFetch';
import { routes } from 'constants/config';
import { ContentGroup, Spinner } from 'ui';
import FeedbackRequestCard from './FeedbackRequestCard';

const FeedbackRequests = props => {
  const fetchData = useFetch(
    routes.ON_DEMAND_PRACTICE.LEARNING.ALL_FEEDBACK_REQUESTS,
  );
  const { data, loading = false, error = false } = fetchData;
  if (loading) {
    return (
      <div className="d-f ai-c jc-c">
        <Spinner className="mr-8" /> {t('common.loading')}
      </div>
    );
  }

  if (error) {
    return <div className="d-f ai-c jc-c">{t('common.notify_error')}</div>;
  }

  const { feedbackRequests } = data;
  return (
    <div>
      <ContentGroup
        items={feedbackRequests}
        title={t('content.groups.feedback_requests')}
        className="mt-24"
      >
        <ContentGroup.Items
          className="d-f fw-w mr-n-24"
          render={feedbackRequest => (
            <FeedbackRequestCard
              key={feedbackRequest.id}
              feedbackRequest={feedbackRequest}
            />
          )}
        />
      </ContentGroup>
    </div>
  );
};

export default FeedbackRequests;
